'use client';

import React, { createContext, useContext, useMemo } from 'react';

import { PartnerConfig } from '@/types';

export interface CobrandedContextValue {
  /** The resolved co-brand config for the current order(s), if any. */
  config?: PartnerConfig;
}

const CobrandedContext = createContext<CobrandedContextValue>({});

export const useCobranded = () => useContext(CobrandedContext);

export const CobrandedProvider: React.FC<{
  readonly config?: PartnerConfig;
  readonly children: React.ReactNode;
}> = ({ config, children }) => {
  const value = useMemo(() => ({ config }), [config]);
  return (
    <CobrandedContext.Provider value={value}>
      {children}
    </CobrandedContext.Provider>
  );
};
